import React from 'react';
import RoboticsLearningPath from './RoboticsLearningPath';

const RoboticsCourse: React.FC = () => {
  return <RoboticsLearningPath />;
};

export default RoboticsCourse;
